// @flow

import type { Endpoints, EntityFieldCollection, SortParams } from '../types';
import { idField, getCreatedAtSort, createdAtField } from '../abstract/StoredEntity';
import type { StoredEntity } from '../abstract/StoredEntity';
import { constructEndpoints } from '../helpers';

class Beacon implements StoredEntity {
    static classInternalName = 'beacon';

    static fields: EntityFieldCollection = {
        id: idField,
        createdAt: createdAtField,
        uuid: {
            displayName: 'UUID',
            recordName: 'uuid',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
        major: {
            displayName: 'Major',
            recordName: 'major',
            dataType: {
                primitive: 'num',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
        minor: {
            displayName: 'Minor',
            recordName: 'minor',
            dataType: {
                primitive: 'num',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
    };

    static fileFields: EntityFieldCollection = {};

    static defaultSort: SortParams = getCreatedAtSort('created_at');

    get id() {
        return this.record[Beacon.fields.id.recordName];
    }

    get displayName() {
        return this.record[Beacon.fields.id.recordName];
    }

    static endpoints: Endpoints = constructEndpoints('beacons');

    constructor(record: any) {
        this.record = record;
    }
}

export default Beacon;
